import React from 'react';
import { Route, Switch } from 'react-router';
import { useTabs } from '../../hooks/useTabs';
import { observer } from 'mobx-react';
import { useWithdrawService } from '../../hooks/useWithdrawService';
import { Steps } from '../../services/WithdrawService';
import { Confirmation } from '../Confirmation';

export const Content: React.FC = observer(() => {
  const { tabs } = useTabs();
  const { currentStep } = useWithdrawService();

  if (currentStep === Steps.CONFIRMATION) {
    return <Confirmation />;
  }

  return (
    <Switch>
      {tabs.map(({ Content, pathname, instrument }) => (
        <Route key={pathname} path={`/${pathname}`}>
          <Content {...instrument} />
        </Route>
      ))}
    </Switch>
  );
});
